import { ChakraBox, UniversalSelect } from '@equip.health/ui';

import { EditNoteFormData } from '~/lib/types/notes/EditNoteFormData';
import { getSelectValue } from '~/lib/util/notes/notes.util';

interface NotesSelectProps {
  error?: string;
  fieldName: string;
  ariaLabel: string;
  isDisabled: boolean;
  isLoading?: boolean;
  isRequired?: boolean;
  multiple?: boolean;
  onFormChange: () => void;
  options: Array<NoteMultiSelectOption>;
  setFieldValue: (
    key: string,
    value: NoteMultiSelectOption | Array<NoteMultiSelectOption>,
  ) => void;
  updateFieldErrorReducer?: (param: { typeError: string | null }) => void;
  placeholder: string;
  values: EditNoteFormData;
  isGroupClassNote?: boolean;
  minWidth?: string;
}

export const NotesSelect = ({
  error = null,
  ariaLabel,
  fieldName,
  isDisabled,
  isLoading = false,
  isRequired = false,
  multiple = false,
  onFormChange,
  options,
  placeholder,
  setFieldValue,
  updateFieldErrorReducer,
  values,
  minWidth = '175px',
}: NotesSelectProps) => {
  const selectValue = getSelectValue(fieldName, values, options);

  return (
    <ChakraBox minWidth={minWidth}>
      <UniversalSelect
        ariaLabel={ariaLabel}
        id={`notes_slim_select__${fieldName}`}
        isClearable={false}
        isDisabled={isDisabled}
        isInvalid={Boolean(error)}
        isLoading={isLoading}
        isSingleSelect={!multiple}
        maxMenuHeight={220}
        onChange={(selected: NoteMultiSelectOption) => {
          setFieldValue(fieldName, selected);
          onFormChange();

          if (updateFieldErrorReducer && selected && isRequired)
            updateFieldErrorReducer({ typeError: null });
        }}
        options={options}
        placeholder={placeholder}
        value={selectValue}
        variant="slim"
      />
    </ChakraBox>
  );
};
